import { Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import FormAddContato from '../../components/FormAddContato';
import { Card, ColCard, Title } from '../../styles';
import { GlobalStyle } from './styles';

export default function StepContatos({ form }) {
  return (
    <>
      <GlobalStyle />
      <Row style={{ height: '90%' }}>
        <ColCard span={12} className="height-71">
          <Card className="height-71">
            <Title>Enviar ordem de carregamento</Title>
            <FormAddContato form={form} />
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepContatos.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
};
